import * as React from "react";
import { cn } from "@readouts/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-gray-200 bg-white px-3.5 py-2 text-sm read-only:text-gray-400 placeholder:select-none placeholder:text-gray-400 outline-none outline-offset-0 transition-colors duration-200 ease-in-out hover:border-gray-300 focus:border-jacksons-purple-600 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
